var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.breadcrumbConfig.title))])])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }